import React from 'react';
import { Card, Typography } from 'antd';
import { CheckCircleOutlined, TrophyOutlined } from '@ant-design/icons';
import RankingTable from './RankingTable';
import './ModernResultsStep.css';

const { Title, Text } = Typography;

const ModernResultsStep = ({
                               data,
                               returnedCriteria,
                               // RankingTable props
                               flags,
                               cycleColor,
                               handleButtonClick,
                               handleUnifiedPrescreenClick,
                               handleSummaryClick,
                               prescreenLoading,
                               getPrescreenButtonColor,
                               isMultiSelect,
                               selectedCandidates,
                               setSelectedCandidates,
                               handleMultiplePrescreen,
                               ENABLE_MULTISELECT_FEATURE,
                               backendURL,
                               jdFilepath,
                               jdText,
                               jobID,
                           }) => {
    return (
        <div className="modern-results-container">
            <div className="modern-results-background">
                <div className="modern-results-content">
                    {/* Header Section */}
                    <div className="modern-results-header">
                        <Title level={1} className="modern-results-title">
                            CV Ranking Complete
                        </Title>
                        <Text className="modern-results-subtitle">
                            Your candidates have been analyzed and ranked based on your criteria
                        </Text>
                    </div>

                    {/* Results Section */}
                    <div className="results-section">
                        <Card className="modern-results-card">
                            <div className="results-header">
                                <TrophyOutlined className="results-icon" />
                                <Title level={2} className="results-title">
                                    Ranking Results
                                </Title>
                                <div className="results-status">
                                    <CheckCircleOutlined className="status-icon" />
                                    <span className="status-text">Analysis Complete</span>
                                </div>
                            </div>

                            <div className="results-table-container">
                                <RankingTable
                                    data={data}
                                    returnedCriteria={returnedCriteria}
                                    flags={flags}
                                    cycleColor={cycleColor}
                                    handleButtonClick={handleButtonClick}
                                    handleUnifiedPrescreenClick={handleUnifiedPrescreenClick}
                                    handleSummaryClick={handleSummaryClick}
                                    prescreenLoading={prescreenLoading}
                                    getPrescreenButtonColor={getPrescreenButtonColor}
                                    isMultiSelect={isMultiSelect}
                                    selectedCandidates={selectedCandidates}
                                    setSelectedCandidates={setSelectedCandidates}
                                    handleMultiplePrescreen={handleMultiplePrescreen}
                                    ENABLE_MULTISELECT_FEATURE={ENABLE_MULTISELECT_FEATURE}
                                    backendURL={backendURL}
                                    jdFilepath={jdFilepath}
                                    jdText={jdText}
                                    jobID={jobID}
                                />
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModernResultsStep;